<template>
    <span>
        <a v-if="isLink" :href="getLink()" class="text-normal"><p class="small">{{formattedDate}}<br/>{{formattedTime}}</p></a>
        <p v-else class="small">{{formattedDate}}<br/>{{formattedTime}}</p>
    </span>
</template>
<script>
import Vue from 'vue';
import M from 'moment';

export default {
    components: {

    },

    props: ['initialValue', 'data', 'css', 'config'],

    watch: {

    },

    computed: {
        formattedDate() {
            const format = _.get(this.config, 'dateFormat');
            if (!format) return '';
            return this.initialValue ? this.parseDatetime(this.initialValue).format(format) : '---';
        },
        formattedTime() {
            const format = _.get(this.config, 'timeFormat');
            if (!format) return '';
            return this.initialValue ? this.parseDatetime(this.initialValue).format(format) : '---';
        },
        isLink() {
            return _.get(this.config, 'isLink');
        },
    },

    methods: {
        getLink() {
            if (!this.isLink) return null;

            const link = this.helpers('uriFormat')(_.get(this.data, 'link', ''));

            return link ? `#${link}` : null;
        },
        parseDatetime(val) {
            if (_.isString(val)) {
                return M(val);
            }

            if (_.isObject(val)) {
                const dt = val.datetime || val.date;
                return M(dt);
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/DateTimeComponent.vue